// extracted by mini-css-extract-plugin
export default {"bandFrequencyHelp":"wifi-toggle_bandFrequencyHelp__kCQbn","bandFrequencyHelpText":"wifi-toggle_bandFrequencyHelpText__n+jT9","bandToggle":"wifi-toggle_bandToggle__9Dfsu"};